import { render, staticRenderFns } from "./CommonAlertModal.vue?vue&type=template&id=124aecbd&scoped=true&"
import script from "./CommonAlertModal.vue?vue&type=script&lang=js&"
export * from "./CommonAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./CommonAlertModal.vue?vue&type=style&index=0&id=124aecbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124aecbd",
  null
  
)

export default component.exports